import React from "react";
const ElectronicSubmission = React.lazy(() =>
  import(/* webpackChunkName: "ElectronicSubmission" */ "../Submissions/ElectronicSubmission/ElectronicSubmission")
);
const SubmissionLog = React.lazy(() =>
  import(/* webpackChunkName: "SubmissionLog" */ "../Submissions/SubmissionLog/SubmissionLog")
);
const EDIResponseLog = React.lazy(() =>
  import(/* webpackChunkName: "EDIResponseLog" */ "../Submissions/EDIResponseLog/EDIResponseLog")
);

export const SubmissionTabsComponent = {
  ElectronicSubmission,
  SubmissionLog,
  EDIResponseLog,
}
const SubmissionTabsObj = () => {
  return [
    {
      title: "Submission",
      name: "submission",
      Component: "ElectronicSubmission",
      // icon: MdSpaceDashboard,
      right: true,
      eventKey: 88,
      key: 8,
      data: { activeTab: "unbilled", visitValidation: "all" }
    },
    {
      title: "Submission Log",
      name: "submissionLog",
      Component: "SubmissionLog",
      // icon: MdSpaceDashboard,
      right: true,
      eventKey: 68,
      key: 9,
      data: {}
    },
    {
      title: "EDI Response Log",
      name: "ediResponseLog",
      Component: "EDIResponseLog",
      // icon: MdSpaceDashboard,
      right: true,
      eventKey: 68,
      key: 10,
      data: {}
    },
    // {
    //   title: "Patient Statement",
    //   name: "patientStatement",
    //   Component: "PatientStatement",
    //   icon: MdSpaceDashboard,
    //   right: true,
    //   eventKey: 68,
    //   key: 11,
    //   data: {}
    // },

  ];
};

export default SubmissionTabsObj;
